import { useFloating, offset, flip, shift } from '@floating-ui/react';
import { Menu } from '@headlessui/react';
import { IconMoreHorizontal } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import clsx from 'clsx';
import { createPortal } from 'react-dom';
import styles from './RowActionsMenu.module.css';

export type TRowAction = 'edit' | 'deactivate' | 'reactivate';

type TProps = {
  isActive: boolean;
  isSelf: boolean;
  onAction: (action: TRowAction) => void;
};

export const RowActionsMenu = ({ isActive, isSelf, onAction }: TProps) => {
  const { refs, floatingStyles } = useFloating({
    placement: 'bottom-end',
    middleware: [offset(4), flip(), shift({ padding: 8 })],
  });

  return (
    <Menu>
      {({ open }) => (
        <>
          <Menu.Button
            as={Button}
            variant="tertiary"
            iconOnly
            aria-label="Row actions"
            ref={refs.setReference}
            className={styles.trigger}
          >
            <IconMoreHorizontal className={styles.triggerIcon} />
          </Menu.Button>
          {open &&
            createPortal(
              <Menu.Items
                static
                className={styles.panel}
                ref={refs.setFloating}
                style={floatingStyles}
              >
                <Menu.Item
                  as="button"
                  type="button"
                  className={styles.item}
                  onClick={() => onAction('edit')}
                >
                  Edit
                </Menu.Item>
                {isActive ? (
                  !isSelf && (
                    <Menu.Item
                      as="button"
                      type="button"
                      className={clsx(styles.item, styles.itemDeactivate)}
                      onClick={() => onAction('deactivate')}
                    >
                      Deactivate
                    </Menu.Item>
                  )
                ) : (
                  <Menu.Item
                    as="button"
                    type="button"
                    className={styles.item}
                    onClick={() => onAction('reactivate')}
                  >
                    Reactivate
                  </Menu.Item>
                )}
              </Menu.Items>,
              document.body,
            )}
        </>
      )}
    </Menu>
  );
};
